module.exports = new __parcel__URL__("page-search.2a20ac44.svg").toString();